import { sendAnalyticsEvent } from '@devsbb/analytics-client';
import { MilestoneOrderProperty } from './types';

export const trackOrderSubmitted = (props: MilestoneOrderProperty): Promise<void> =>
    sendAnalyticsEvent<MilestoneOrderProperty>('Order Submitted', props);
